import { createStableCacheKey } from '@app/services/cache/cache-key.helpers';
import { appCache } from '@app/services/cache/redis-cache.service';

const isEnabled = (value: string | undefined, fallback: boolean): boolean => {
    if (!value) {
        return fallback;
    }

    return ['1', 'true'].includes(value.toLowerCase());
};

export const cacheKey = (namespace: string, payload: unknown): string =>
    createStableCacheKey(namespace, payload);

export const cacheTtl = (envKey: string, fallbackSeconds?: number): number => {
    const envValue = process.env[envKey];

    if (envValue === undefined) {
        return fallbackSeconds ?? 0;
    }

    return Number(envValue);
};

export const cache = async <TValue>(
    key: string,
    factory: () => Promise<TValue>,
    ttlSeconds: number,
): Promise<TValue> => {
    if (typeof window !== 'undefined') {
        return factory();
    }

    const cacheEnabled = isEnabled(process.env.APP_CACHE_ENABLED, true);

    if (!cacheEnabled || ttlSeconds <= 0) {
        return factory();
    }

    const { value } = await appCache.get(key);

    if (value) {
        return JSON.parse(value) as TValue;
    }

    const freshValue = await factory();
    await appCache.set(key, JSON.stringify(freshValue), ttlSeconds);

    return freshValue;
};
